/* eslint-disable no-param-reassign */
import * as marietta from '../..';
import Dialog from './Dialog';

// 文言を中央揃えにするクラス（スタイルは _webcad2d.scss の .dialogBody 配下）
const CENTER_TEXT_CLASS = 'textCenter';

class Alert {
    viewObj: HTMLElement;

    _draggable: Boolean = true;

    globalCleanUpFunc: Function;

    dialogOffset: marietta.core.Point;

    dialogPosition: marietta.core.Point;

    static callbackYes: Function;

    prevDialog:Dialog;

    public showHeaderCloseButton: boolean = true;

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line no-useless-constructor
    constructor() {
      //
      console.log('AlertAlertAlertAlert');
    }

    /**
     * ダイアログの作成
     */
    show(message, title = '', cbOK = null, showCloseButton = true, _prevDialog = null, isCenterText = false) {
      // 戻り
      marietta.core.view.Alert.callbackYes = cbOK;
      this.showHeaderCloseButton = showCloseButton;
      this.prevDialog = _prevDialog;

      // お掃除
      if (document.getElementById('alertDialog'))document.getElementById('alertDialog').remove();

      const parser = new DOMParser();

      // エレメント初期化
      this.viewObj = document.createElement('div');
      this.viewObj.setAttribute('id', 'alertDialog');
      this.viewObj.classList.add('dialogBox');
      if (this.prevDialog) {
        const zIndex = Number(getComputedStyle((this.prevDialog.viewObj)).zIndex);
        this.viewObj.style.zIndex = String(zIndex + 2);
      }
      let elHeader = '';
      let elBody = '';
      let elFooter = '';

      // ヘッダー生成
      elHeader += '<div class="dialogHeader">\n';
      if (this.showHeaderCloseButton) {
        elHeader += '<div class="dialogClose"><button class="dialogCloseBtn"><i class="icon icon-close4">×</i></button></div>\n';
      }
      elHeader += `<div class="dialogTitle">${title}</div>`;
      elHeader += '</div>';

      // ボディ生成
      elBody += '<div class="dialogBody">\n';
      elBody += isCenterText ? `<p class="${CENTER_TEXT_CLASS}">\n` : '<p>\n';
      elBody += message;
      elBody += '</p>';
      elBody += '</div>';

      // コントロールバー(フッター)生成
      elFooter += '<div class="dialogFooter">\n';
      elFooter += '<button value="true"><span class="jp">閉じる</span><span class="en">Close</span></button>';
      elFooter += '</div>';

      this.viewObj.append(parser.parseFromString(elHeader, 'text/html').body.children[0]);
      this.viewObj.append(parser.parseFromString(elBody, 'text/html').body.children[0]);
      this.viewObj.append(parser.parseFromString(elFooter, 'text/html').body.children[0]);
      this.viewObj.querySelectorAll('button').forEach((element) => {
        element.addEventListener('click', this.close);
      });

      // ダイアログ用コンテナに追加
      const container = document.querySelector('#dialogContainer');
      container.appendChild(this.viewObj);

      this.viewObj.style.display = 'block';

      // ダイアログの移動
      const self = this;
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (this._draggable) {
        if (ua.isMobile || ua.isTablet) {
          document.querySelector('.dialogHeader').addEventListener('touchstart', self.headerMouseDownHandler);
          // タイトルバーの×ボタン
          if (this.showHeaderCloseButton) {
            this.viewObj.querySelector('.dialogCloseBtn').addEventListener('touchend', this.close, { passive: false });
          }
        } else {
          document.querySelector('.dialogHeader').addEventListener('mousedown', self.headerMouseDownHandler);
          // タイトルバーの×ボタン
          if (this.showHeaderCloseButton) {
            this.viewObj.querySelector('.dialogCloseBtn').addEventListener('click', this.close);
          }
        }
        (<HTMLElement>document.querySelector('.dialogHeader')).style.cursor = 'move';
        this.dialogOffset = new marietta.core.Point(0, 0);
        this.dialogPosition = new marietta.core.Point(0, 0);
        ua = null;
      }

      this.centerDialog();
      if (this.prevDialog) this.handleModal();
    }

    /**
     * ダイアログを閉じる
     */
    close = () => {
      this.viewObj.remove();
      if (this.showHeaderCloseButton) {
        this.viewObj.querySelector('.dialogCloseBtn').removeEventListener('click', this.close);
      }

      // コールバックのお掃除関数
      this.globalCleanUpFunc();

      if (this.prevDialog) {
        marietta.webcad.WebCADGlobal.currentDialog = this.prevDialog;
        if (marietta.webcad.WebCADGlobal.currentDialog.hasModal)marietta.webcad.WebCADGlobal.currentDialog.handleModal();
      }

      if (marietta.core.view.Alert.callbackYes != null) {
        marietta.core.view.Alert.callbackYes();
      }
    }

    /**
     * 内容の追加
     */
    buildContent= () => {
      // overrideして使用.
    }

    /**
     * ダイアログを中心へ
     */
    centerDialog() {
      // ダイアログの幅調整
      let maxW = 0;
      (this.viewObj).childNodes.forEach((elem: HTMLElement) => {
        if (maxW < elem.getBoundingClientRect().width) {
          maxW = Math.ceil(elem.getBoundingClientRect().width);
        }
        elem.style.display = 'block';
      });
      this.viewObj.style.width = `${String(maxW)}px`;

      // ダイアログの高さ調整
      let boxHeight = 0;
      (this.viewObj).childNodes.forEach((elem: HTMLElement) => {
        boxHeight += elem.getBoundingClientRect().height;
      });
      this.viewObj.style.height = `${String(boxHeight)}px`;
    }

    /**
     * ダイアログの移動開始
     */
    headerMouseDownHandler = (e: any) => {
      e.preventDefault();
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        // パネルのクリック位置格納
        this.dialogOffset.x = (<TouchEvent>e.originalEvent).targetTouches[0].pageX;
        this.dialogOffset.y = (<TouchEvent>e.originalEvent).targetTouches[0].pageY;
        document.addEventListener('touchmove', this.headerMouseMoveHandler, { passive: false });
        document.addEventListener('touchend', this.headerMouseUpHandler, { passive: false });
      } else {
        // パネルのクリック位置格納
        this.dialogOffset.x = e.clientX;
        this.dialogOffset.y = e.clientY;
        document.addEventListener('mousemove', this.headerMouseMoveHandler);
        document.addEventListener('mouseup', this.headerMouseUpHandler);
      }
      ua = null;
    }

    headerMouseMoveHandler = (e: MouseEvent | TouchEvent) => {
      e.preventDefault();
      let posX: number;
      let posY: number;
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        posX = (<TouchEvent>e).targetTouches[0].pageX - this.dialogOffset.x + this.dialogPosition.x;
        posY = (<TouchEvent>e).targetTouches[0].pageY - this.dialogOffset.y + this.dialogPosition.y;
      } else {
        posX = (<MouseEvent>e).clientX - this.dialogOffset.x + this.dialogPosition.x;
        posY = (<MouseEvent>e).clientY - this.dialogOffset.y + this.dialogPosition.y;
      }
      const cssTransform = `translate(${posX}px,${posY}px)`;
      this.viewObj.style.transform = cssTransform;
    }

    headerMouseUpHandler = (e: MouseEvent) => {
      e.preventDefault();
      // transformで移動したパネルの配置格納
      const cssVal: string = this.viewObj.style.transform;
      if (cssVal.indexOf('matrix') > -1) {
        const cssValTemp: string[] = cssVal.split(', ');
        this.dialogPosition.x = parseInt(cssValTemp[4], 10);
        this.dialogPosition.y = parseInt(cssValTemp[5].split(')')[0], 10);
      }
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.removeEventListener('touchmove', this.headerMouseMoveHandler);
        document.removeEventListener('touchend', this.headerMouseUpHandler);
      } else {
        document.removeEventListener('mousemove', this.headerMouseMoveHandler);
        document.removeEventListener('mouseup', this.headerMouseUpHandler);
      }
      ua = null;
    }

    handleModal = () => {
      document.getElementById('modalBg').style.display = 'block';
      const zIndex = Number(getComputedStyle(this.viewObj).zIndex);
      document.getElementById('modalBg').style.zIndex = String(zIndex - 1);
    }
}

export default Alert;
